import React from "react";
import { FaUserDoctor } from "react-icons/fa6";
import { formatTo12Hour } from "../../../../utils/helpers";

export default function SessionsTab({ completedSessions }) {
  if (!completedSessions?.length) {
    return (
      <p className="text-gray-500 text-center py-8">
        No completed sessions found
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-gray-800">Completed Sessions</h3>
      {completedSessions.map((session) => (
        <div
          key={session.sessionId}
          className="rounded-lg p-4 bg-white shadow-sm"
        >
          <div className="flex items-center gap-2 bg-primary/10 mb-1 p-3 rounded-md">
            <p className="text-sm text-gray-600 flex items-center gap-2">
              <FaUserDoctor /> Specialist:
            </p>
            <p className="font-semibold text-primary">
              {session.specialistName || "N/A"}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="bg-primary/5 p-2 rounded-md">
              <p className="text-sm text-gray-600">Date</p>
              <p className="font-semibold text-primary">
                {new Date(session.sessionDate).toLocaleDateString()}
              </p>
            </div>
            <div className="bg-primary/5 p-2 rounded-md">
              <p className="text-sm text-gray-600">Start Time</p>
              <p className="font-semibold text-primary">
                {formatTo12Hour(session.startTime)}
              </p>
            </div>
          </div>
          {session.notes && (
            <p className="mt-3 text-gray-700 text-sm bg-gray-50 p-3 rounded-lg border border-gray-200">
              Note: {session.notes}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}